export const TIMER_DURATION = 30;
export const OTP_LENGTH = 4;

export const PROGRESS_STEPS = [
  { id: 1, label: 'Contact Details' },
  { id: 2, label: 'Vehicle Details' },
  { id: 3, label: 'Disposal Options' },
  { id: 4, label: 'Valuation' },
];
